// assets
import MenuTopup from 'ui-component/icons/menuTopup';
import MenuFinance from 'ui-component/icons/menuFinance';
import MenuHelp from 'ui-component/icons/menuHelp';
import Safe from 'ui-component/icons/safe2';
import Agent from 'ui-component/icons/agent';
import { Menu } from './type';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard: Menu = {
  id: 'account',
  title: '账户管理',
  i18nTitle: 'account',
  type: 'group',
  children: [
    {
      id: 'online',
      title: '在线充值',
      i18nTitle: 'online',
      type: 'item',
      url: '/account/topup',
      icon: MenuTopup,
      breadcrumbs: false,
      _hidden: (power: any) => power?.hiddenTopup
    },

    {
      id: 'transaction',
      title: '资金活动',
      i18nTitle: 'transaction',
      type: 'item',
      url: '/account/transaction',
      icon: MenuFinance,
      breadcrumbs: false
    },
    {
      id: 'help',
      title: '帮助中心',
      i18nTitle: 'help',
      type: 'item',
      fn: (language: any) => {
        if (language === 'zh') {
          window.open('https://meitianhenlafeng.gitbook.io/hlcard-bang-zhu-zhong-xin');
        } else {
          window.open('https://meitianhenlafeng.gitbook.io/hlcard-user-guide-manual');
        }
      },
      icon: MenuHelp,
      breadcrumbs: false
    },
    // {
    //   id: 'customer',
    //   title: '在线客服',
    //   i18nTitle: 'customer',
    //   type: 'item',
    //   url: '/account/help',
    //   icon: Help,
    //   breadcrumbs: false
    // },
    {
      id: 'agent',
      title: '代理中心',
      i18nTitle: 'agent',
      type: 'item',
      url: '/agent',
      icon: Agent,
      _hidden: (power: any) => power?.agent,
      breadcrumbs: false
    },
    {
      id: 'risk',
      title: '地址检测',
      i18nTitle: 'risk',
      type: 'item',
      url: '/account/risk',
      icon: Safe,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
